import { Component, OnInit } from '@angular/core';
import { IPerformanceChartItem, IPerformanceChartSupplierMap, IPerformanceChartTimingItem} from '../../models/IPerformanceChart';
import { IPerformanceIndicator } from '../../models/IPerformanceIndicators';
import { INatRepPerformanceChart, INatRepPerformanceChartPoint } from '../../models/INatRepPerformanceChart';
import { FezaDataService } from '../../services/fezadata.service';
import { Observable } from 'rxjs/Observable';
import { NgbInputDatepicker, NgbTab, NgbTabset } from '@ng-bootstrap/ng-bootstrap';
import { forEach } from '@angular/router/src/utils/collection';
import { NatRepServiceService } from '../../services/nat-rep-service.service';
import { FileService } from '../../services/file.service';
import { environment } from '../../../environments/environment';
import { ChartOptions, ChartType, ChartDataSets } from 'chart.js';
import { Color } from 'ng2-charts';
import { forkJoin } from 'rxjs/observable/forkJoin';

@Component({
  selector: 'app-performance',
  templateUrl: './performance.component.html',
  styleUrls: ['./performance.component.css']
})
export class PerformanceComponent implements OnInit {
  loading: boolean;
  performance$: Observable<Map<string, IPerformanceIndicator>>;
  natRepPerformance$: Observable<INatRepPerformanceChart>;
  natRepDetailsFilePath: string;

  constructor(private fezaService: FezaDataService,
    private natRepService: NatRepServiceService,
    private fileService: FileService) {

    this.natRepDetailsFilePath = environment.natRepUrl + "/api/v1/natrep/details"
  }


  public lineChartType = 'line';
  public lineChartLegend = true;
  public dayLineChartData = [];
  public dayLineChartLabels = [];

  public hourLineChartData = [];
  public hourLineChartLabels = [];

  public supplierLineChartData = [];

  public natRepLineChartData = [];
  public natRepLineChartLabels: string[] = [];

  public perfChartLabels: string[] = [];
  public perfChartType: ChartType = "bar";
  public perfChartLegend = true;
  
  public perfChartData: ChartDataSets[] = [
    { data: [], label: '5 Sec.', stack: 'a' },
    { data: [], label: '5 to 10 Sec.', stack: 'a' },
    { data: [], label: '10+ Sec.', stack: 'a' },
    { data: [], label: '% Feasible', stack: 'b', "type" : "line" }
  ];
  
  public perfChartOptions: (ChartOptions & { annotation: any }) = {
    responsive: true,
    scales: {
      yAxes: [{ stacked: true,  }],
    },
    legend: { onClick: (e) => e.stopPropagation() /*hiding a series mess up my math.*/},
    tooltips: {
      callbacks: {
        label: function (tooltipItem, data) {

          //iterate all to get percent back
          let maxTotalValue = 0;
          for (let i = 0; i < data.datasets[0].data.length; i++) {
            let five = data.datasets[0].data[i] || 0;
            let ten = data.datasets[1].data[i] || 0;
            let tenPlus = data.datasets[2].data[i] || 0;
            let itemMax = five + ten + tenPlus;
            maxTotalValue = itemMax > maxTotalValue ? itemMax : maxTotalValue;
          }
          // now data for the item hovered over.

          let dataIndex = tooltipItem.index || 0;
          let percent = Math.floor(Math.round(maxTotalValue > 0? 1.0 * (data.datasets[3].data[dataIndex] || 0) / maxTotalValue * 100: 0));
          let five = data.datasets[0].data[dataIndex] || 0;
          let ten = data.datasets[1].data[dataIndex] || 0;
          let tenPlus = data.datasets[2].data[dataIndex] || 0;
          let total = five + ten + tenPlus;

          if (total === 0)
            return `Zero requests!`
          else
            return `${percent}% Feasible     5 sec: ${Math.round(five / total * 100).toFixed(0)}%     10 sec:${Math.round(1.0 * ten / total * 100).toFixed(0)}%     10+ sec:${Math.round(1.0 * tenPlus / total * 100).toFixed(0)}%      ${total} requests`
            //X% Feasible   5 Sec : X%   10 sec:Y%   10+:Z%  XXX total  requests.
        }
      }
    }
  };

  public perfChartColors: Color[] = [
    {
      //5 seconds
      borderColor: 'green',
      backgroundColor: 'rgb(0,255,0,0.3)',
    },
    {//10 sec
      borderColor: 'yellow',
      backgroundColor: 'rgb(255,255,0,0.3)',
    },
    {//10+
      borderColor: 'red',
      backgroundColor: 'rgb(255,0,0,0.3)',
    },
    {//feasible
      borderColor: 'blue',
      backgroundColor: 'rgb(0,0,255,0)',  //transparent
    }
  ];

  public lineChartOptions = {
    scaleShowVerticalLines: true,
    responsive: true
  };

  public natRepChartOptions = {
    scaleShowVerticalLines: true,
    responsive: true,
    tooltips: {
      callbacks: {
        label: function (tooltipItem, data) {
          for (let p of data.datasets[tooltipItem.datasetIndex].myChartData) {
            let item = p as INatRepPerformanceChartPoint;
            if (`${item.month}-${item.day}` == tooltipItem.xLabel) {
              return `Avg ms:${item.avgDuration.toLocaleString()} Avg Vars.:${item.avgVariables} supported:${1.0 * item.supportedCalls / item.count * 100.0}%`;
            }
          }
          return "";
        }
      }
    }        
  };

  

  ngOnInit() {
    this.performance$ = this.fezaService.getPerformanceIndicators();
    this.natRepPerformance$ = this.natRepService.getPerformanceChart();

    this.natRepPerformance$.subscribe(chart => {
      var names: string[] = [];
      var data = [];
      this.natRepLineChartLabels = [];
      for (let name in chart.series) {
        names.push(name);
        data.push({ data: [], label: name, hidden: false, myChartData: chart.series[name] });
        //monthDays is a unique set of all the month-days from all series, to make a graph look nicer
        for (var item of chart.series[name])
          this.natRepLineChartLabels.push(`${item.month}-${item.day}`);
        this.natRepLineChartLabels = this.natRepLineChartLabels.filter((x, i, a) => x && a.indexOf(x) === i);//dem dups
      }
      for (let monthDay of this.natRepLineChartLabels) {
        names.forEach((name, index) => {
          var point = 0;
          for (let item of chart.series[name]) {
            if (`${item.month}-${item.day}` === monthDay) {
              point = item.avgDuration
              break;
            }
          }
          data[index].data.push(point);
        });
      }
      this.natRepLineChartData = data;
    });

    console.log(this.performance$);

    this.fezaService.getPerformanceChartOverallByHour().subscribe(byHour => this.setupChartByHour(byHour));
    this.fezaService.getPerformanceChartOverallTimingBreakdown().subscribe(byTiming => this.setupChartbyTiming(byTiming));
   
    forkJoin(
      this.fezaService.getPerformanceChartOverallByDay(),
      this.fezaService.getPerformanceChartOverallByDayBySupplier(),
    ).subscribe(data => {
      var [byDay, bySupplier] = data;
      var dayList = this.setupChartByDay(byDay);
      this.setupChartBySupplier(byDay, dayList, bySupplier);
    });
  }

  setupChartBySupplier(daySeries: IPerformanceChartItem[], dayData: string[], supplierSeries: IPerformanceChartSupplierMap) {
    //by supplier
    var supplierNames: string[] = [];
    var supplierData = [];
    for (let name in supplierSeries) {
      supplierNames.push(name);
      var isHidden: boolean = false;// = name.toLowerCase().indexOf("isay") === -1 && name.toLowerCase().indexOf("livra") == -1 && name.toLowerCase().indexOf("ipsos") == -1;
      supplierData.push({ data: [], label: name, hidden: isHidden });
    }
    //let's use the per day lables from day series
    //find each point in the supplier list that matches, or zero, and add that to the supplier's series
    //maybe change the backend end to send dictionary of dicationaries if these seems slow later with much larger numbers of suppliers
    for (let item of daySeries) {
      supplierNames.forEach((name, index) => {
        var point = 0;
        var series: IPerformanceChartItem[] = supplierSeries[name];
        for (let p of series) {
          if (p.name === item.name) {
            point = p.value;
            break;
          }
        }
        supplierData[index].data.push(point);
      });
    }
    supplierData.push({ data: dayData, label: "Overall response", hidden: false })
    this.supplierLineChartData = supplierData;
  }

  getKeys(perf: Map<string, IPerformanceIndicator>): string[] {
    let keys = Object.keys(perf || {});
    return keys.sort();
  }

  onGetDetailsLog(beatLogName) {
    this.fileService.downloadSecureFile(this.natRepDetailsFilePath, `NatRepDetails.xlsx`);
  }


  setupChartByHour(hourSeries: IPerformanceChartItem[]) {
    var hourLabels = [];
    var hourData = [];
    for (let item of hourSeries) {
      hourLabels.push(item.name);
      hourData.push(item.value.toFixed(1));
    }
    this.hourLineChartData = [{ data: hourData, label: "By Hour" }];
    this.hourLineChartLabels = hourLabels;
  }

  setupChartbyTiming(timingSeries: IPerformanceChartTimingItem[]) {
    this.perfChartLabels = [];
    this.perfChartData[0].data = [];
    this.perfChartData[1].data = [];
    this.perfChartData[2].data = [];
    this.perfChartData[3].data = [];
    this.perfChartLabels = [];
    var maxTotalValue = 0;
    for (let item of timingSeries) {
      var itemMax = item.fiveSec + item.tenSec + item.tenPlusSec;
      maxTotalValue = itemMax > maxTotalValue ? itemMax : maxTotalValue;
    }
    for (let item of timingSeries) {
      let label = `${item.start} to ${item.end}`;
      this.perfChartLabels.push(label);
      this.perfChartData[0].data.push(item.fiveSec);
      this.perfChartData[1].data.push(item.tenSec);
      this.perfChartData[2].data.push(item.tenPlusSec);
      this.perfChartData[3].data.push(1.0 * item.percentFeasible / 100.0 * maxTotalValue);
    }
  }

  setupChartByDay(daySeries: IPerformanceChartItem[]) : string[]  {
    //by day
    let labels = [];
    let dayData: string[] = [];
    for (let item of daySeries) {
      labels.push(item.name);
      dayData.push(item.value.toFixed(1));
    }
    this.dayLineChartData = [{ data: dayData, label: "By Day" }];
    this.dayLineChartLabels = labels;
    return dayData;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/performance/performance.component.ts